import { UseIonRouterResult } from '@ionic/vue';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import userApi from '@/api/user';



export const createNotificationChannel = async () => {

  // Ejecuta la creación del canal solo en Android
  if (Capacitor.getPlatform() !== 'android') return;

  try {
    await PushNotifications.createChannel({
      id: import.meta.env.VITE_CHANNEL,
      name: 'Novedades de Insecal Inspeccion SL',
      description: 'Canal para enviar novedades a los clientes de la app',
      importance: 5,
      visibility: 1,
      vibration: true,
    });
    console.log('Channel created successfully: ' + import.meta.env.VITE_CHANNEL);
  } catch (e) {
    console.error('Error creating channel:', e);
  }
};

export const registerNotifications = async () => {

  if (Capacitor.getPlatform() === 'web') {
    console.warn('PushNotifications not supported on web.');
    return;
  }

  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    throw new Error('User denied permissions!');
  }

  await PushNotifications.register();
}

export const addListeners = async (user:number,router:UseIonRouterResult) => {

  if (Capacitor.getPlatform() === 'web') {
    console.error('PushNotifications not supported on web.');
    return;
  }
  //GENERATE TOKEN FOR DEVICE AND STORE TO DB

  await PushNotifications.addListener('registration', token => {

      userApi.setTokenDevice(user, token.value);
  });

  //EXECUTE WHEN REGISTRATION FAILS
  await PushNotifications.addListener('registrationError', err => {
    console.error('Registration error: ', err.error);
  });

  //EXECUTE WHEN NOTIFICATION IS RECEIVED
  await PushNotifications.addListener('pushNotificationReceived', notification => {
    console.log('Push notification received: ', notification);
  });

  await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
    console.log('Push notification action performed', notification.actionId);
    console.log(notification);
    //console.log(router);
    
    //const route = notification.notification.data.route;
    
      // if (route) {
      //   router.replace(route);  // Redirigir a la ruta especificada en la notificación
      // }

    const data = notification.notification.data

    if (data.click_action === 'OPEN_NOTIFICATION') {
      // Navega a la ruta específica definida en tu app
      router.push('/tabs/notificaciones');
    }
  });

  
}

export const getDeliveredNotifications = async () => {

  if (Capacitor.getPlatform() === 'web') {
    console.warn('PushNotifications not supported on web.');
    return;
  }
  const notificationList = await PushNotifications.getDeliveredNotifications();
  console.log('delivered notifications', notificationList);
}

export const listChannels = async () => {

  // Ejecuta la lista de canales solo en Android
  if (Capacitor.getPlatform() !== 'android') return;
  
  try {
    const channels = await PushNotifications.listChannels();
    console.log('Available channels:', channels);
  } catch (e) {
    console.error('Error listing channels:', e);
  }
};